// Copyright (c) 2023 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { GRID_TAGS_VIEW_TYPE } from "../../../app/localStorageKeys"

export type StorageReader = () => Observable<Slice.TagsViewType>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(GRID_TAGS_VIEW_TYPE)
    if (data !== null) {
      // convert to number for matching index from TagsViewType enum
      return of(Number(data))
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadTagsViewType = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.loadTagsViewTypeFromStorage.match),
      mergeMap(_ => load().pipe(
        map(Slice.setTagsViewType),
        catchError(_ => of(Actions.loadTagsViewTypeFromStorageFailed())),
      )),
    )

export default loadTagsViewType(load)
